<div class = "header-mobile">
    <img src = "/assets/conectio-logo.png" alt="Conectio" class="logo">
</div>  